<template>
	<v-container id="split_fullscreen" fluid class="ma-0 pa-0">
    <v-col class="ma-0 pa-0" cols="12">
			<v-col class="ma-0 pa-5" cols="12" align="center">
        <v-row class="ma-0 pa-0 mb-3" justify="end">
          <v-col class="ma-0 pa-0" cols="auto">
            <v-btn id="transparent_btn" elevation="0" @click="goDashboard">
              <v-img src="@/assets/images/video_fullscreen.png"></v-img>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col v-if="viewCount === 4" class="ma-0 pa-0" cols="12" :key="view4">
						<v-row class="ma-0 pa-2" justify="center">
							<v-col v-for="(item, index) in 2" :key="index" class="ma-0 pa-0" cols="6">
								<v-col v-for="(item_nest, index_nest) in 2" :key="index_nest" class="ma-0 pa-0" cols="12">
                  <v-col v-if="checkSplitScreenCameraList(index, index_nest, 2)"
                         id="camera_4box" class="ma-0 pa-0 ml-1 mr-1 mb-2"
                         @click="goVideoPlayer(index_nest + 2*index)"
                         style="cursor: pointer">
                    <v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
                      {{getSplitName(index, index_nest, 2)}}
                    </v-col>
                    <video :id="'example-4-video' + (index_nest + 2*index)" width="100%" height="100%" muted
                           class="ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom"
                           style="object-fit: fill;width:100%;height:100%;">
                    </video>
                  </v-col>
                  <v-col v-else id="camera_4box" class="ma-0 pa-0 ml-1 mr-1 mb-2">
                    <video :id="'example-4-video' + (index_nest + 2*index)" width="100%" height="100%" muted
                           class="ma-2 pa-0 video-js vjs-default-skin vjs-big-play-centered vjs-custom">
                    </video>
                    <v-col :id="'no-data-video' + (index_nest + 2*index)" class="video_grey_box" style="display:flex;">
                      {{t('noData')}}
                    </v-col>
                  </v-col>
								</v-col>
							</v-col>
						</v-row>
					</v-col>

          <v-col v-if="viewCount === 9" class="ma-0 pa-0" cols="12" :key="view9">
						<v-row class="ma-0 pa-2" align="center">
							<v-col v-for="(item, index) in 3" :key="index" class="ma-0 pa-0" cols="4">
								<v-col v-for="(item_nest, index_nest) in 3" :key="index_nest" class="ma-0 pa-0 pr-1 pl-1 mb-2" cols="12">
                  <v-col v-if="checkSplitScreenCameraList(index, index_nest, 3)"
                         id="camera_9box" class="ma-0 pa-0"
                         @click="goVideoPlayer(index_nest + 3*index)"
                         style="cursor: pointer">
                    <v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
                      {{getSplitName(index, index_nest, 3)}}
                    </v-col>
                    <video :id="'example-9-video' + (index_nest + 3*index)" width=550 height=350 muted
                           class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom"
                           style="object-fit: fill;width:100%;height:100%;">
                    </video>
                  </v-col>
                  <v-col v-else id="camera_9box" class="ma-0 pa-0">
                    <video :id="'example-9-video' + (index_nest + 3*index)" muted
                           class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
                    </video>
                    <v-col :id="'no-data-video' + (index_nest + 3*index)" class="video_grey_box" style="display:flex;">
                      {{t('noData')}}
                    </v-col>
                  </v-col>
								</v-col>
							</v-col>
						</v-row>
					</v-col>

          <v-col v-if="viewCount === 16" class="ma-0 pa-0" cols="12" :key="view16">
						<v-row class="ma-0 pa-2" align="center">
							<v-col v-for="(item, index) in 4" :key="index" class="ma-0 pa-0" cols="3">
								<v-col v-for="(item_nest, index_nest) in 4" :key="index_nest" class="ma-0 pa-0 pr-1 pl-1 mb-2" cols="12">
                  <v-col v-if="checkSplitScreenCameraList(index, index_nest, 4)"
                         id="camera_16box" class="ma-0 pa-0"
                         @click="goVideoPlayer(index_nest + 4*index)"
                         style="cursor: pointer">
                    <v-col id="camera_select_bottom_bar" class="ma-0 pa-0" cols="12">
                      {{getSplitName(index, index_nest, 4)}}
                    </v-col>
                    <video :id="'example-16-video' + (index_nest + 4*index)" width=550 height=350 muted
                           class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom"
                           style="object-fit: fill;width:100%;height:100%;">
                    </video>
                  </v-col>
                  <v-col v-else id="camera_16box" class="ma-0 pa-0">
                    <video :id="'example-16-video' + (index_nest + 4*index)" muted
                           class="ma-2 pa-0 video-js video-js-9 vjs-default-skin vjs-big-play-centered vjs-custom">
                    </video>
                    <v-col :id="'no-data-video' + (index_nest + 4*index)" class="video_grey_box" style="display:flex;">
                      {{t('noData')}}
                    </v-col>
                  </v-col>
								</v-col>
							</v-col>
						</v-row>
					</v-col>
        </v-row>
			</v-col>
		</v-col>
    <NameChangeDialog :dialogVisible="nameChangeDialogVisible" :editType="editNameType"
      :currentId="currentId" :currentName="currentName"
      @nameUpdate="nameUpdateFunc" @visible="nameChangeDialogVisibleFunc"/>
		<SearchCameraDialog :dialogVisible="searchCameraDialogVisible"
			@visible="searchCameraDialogVisibleFunc" @selectCamera="selectCameraFunc" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import privateSplitMixin from './mixin/privateSplitScreen'
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import ja from 'video.js/dist/lang/ja.json';
import 'videojs-contrib-hls';
import $ from 'jquery';
import SearchCameraDialog from '../components/SelectCameraDialog.vue';
import NameChangeDialog from '@/components/dialogs/NameChangeDialog.vue';
import { isIOS, isSafari } from 'mobile-device-detect';

export default {
	components: {
		SearchCameraDialog, NameChangeDialog
	},
	mixins: [mixin.common, privateSplitMixin],
	data: () => ({
    nameChangeDialogVisible: false,
		searchCameraDialogVisible: false,
		splitScreenSelectMenu: false,
		splitScreenCameraList: [],
		selectedSplitScreen: '',
		splitScreenList: [],
		splitScreenId: '',
		editNameType: 'privateSplitList',
		currentId: '',
		currentName: '',
		currentItemIndex: 0,
		loading: false,
		players: [],
		viewCount: 4,
		view4: 0,
    view9: 10,
    view16: 100,
    playerOptions: { language: 'ja', languages: { ja }, },
		streamingCount: 0,
    pausePlayInterval: null, // 초기화
	}),
	watch: {
		selectedSplitScreen: function(item) {
			this.$store.commit('setSelectedSplitScreen', item);
			this.getSplitListCameras(0);
		}
	},
  created() {
    if(this.$route.query.viewCount != undefined) this.viewCount = Number(this.$route.query.viewCount);
		// 이벤트 리스너 등록
    document.addEventListener("fullscreenchange", this.fullScreenChangeHandler);
    document.addEventListener("webkitfullscreenchange", this.fullScreenChangeHandler);
    document.addEventListener("mozfullscreenchange", this.fullScreenChangeHandler);
    document.addEventListener("MSFullscreenChange", this.fullScreenChangeHandler);
	},
  async mounted() {
    await this.getSplitList();
		await this.goFullScreen();
		window.addEventListener('keyup', this.escDetect);
    if (isSafari) {
      this.initializePausePlayInterval();
    }
  },
	beforeDestroy() {
		window.removeEventListener('keyup', this.escDetect);
		try {
			for(let i = 0; i < this.players.length; i++) {
				// 중간에 스트리밍 되지 않은 비디오는 dispose 하면 에러가 나기 때문에 if문으로 처리
				if(this.players[i]) this.players[i].dispose();
			}
      if (this.pausePlayInterval) {
        clearInterval(this.pausePlayInterval);
      }
		} catch(e) { 
      console.log(e);
    }
		// 컴포넌트가 파괴되기 전에 이벤트 리스너 해제
    document.removeEventListener("fullscreenchange", this.fullScreenChangeHandler);
    document.removeEventListener("webkitfullscreenchange", this.fullScreenChangeHandler);
    document.removeEventListener("mozfullscreenchange", this.fullScreenChangeHandler);
    document.removeEventListener("MSFullscreenChange", this.fullScreenChangeHandler);
  },
  methods: {
		/*
		* 함수가 없는경우 ./mixin/privateSplitScreen.js 에서 찾을것
		*/
		tsg(t) {
      return this.$t("lang.group." + t);
    },
    goDashboard() {
      this.pushRoute('/private/store-cctv', { view: 'split' });
    },
		escDetect(event) {
			if(event.keyCode == 27 || event.which == 27) { // esc 감지
				this.pushRoute('/private/store-cctv', { view: 'split' });
			}
		},
		closeNameChangeDialog(value) {
      if(this.nameChangeDialogVisible != true) this.splitScreenSelectMenu = false;
      this.selectedSplitScreen = value;
    },
		nameChangeDialogFunc(id, name) {
      this.editNameType = 'privateSplitList';
      this.currentId = id;
      this.currentName = name;
      this.nameChangeDialogVisible = true;
      this.splitScreenSelectMenu = true;
    },
		nameUpdateFunc(item) {
      let currentIndex = this.splitScreenList.findIndex(r => r.id === item.id);
      this.splitScreenList[currentIndex].splitName = item.splitName;
      this.selectedSplitScreen = item.splitName;
    },
		nameChangeDialogVisibleFunc(visible) {
      this.nameChangeDialogVisible = visible;
    },
		searchCameraDialogVisibleFunc(visible) {
			this.searchCameraDialogVisible = visible;
		},
		selectCameraFunc(camera) {
			this.$vloading.show();
      let params = {
        index: this.currentItemIndex,
        contractCd: camera.contractCd,
        portNo: camera.portNo,
        thingType: camera.thingType
      };
      this.networkController.addPrivateUserSplitScreenCamera(params, this.splitScreenId)
      .then((res) => {
				console.log(res.data);
				this.splitScreenCameraList = res.data.cameras;
        this.$vloading.hide();
				this.getSplitListCameras(0);
      }).catch(error => {
        this.$vloading.hide();
      });
		},
		checkSplitScreenCameraList(idx, index_nest, total) {
			return this.splitScreenCameraList[this.splitScreenCameraList.findIndex(
				r => r.index === index_nest + total*idx)] !== undefined
		},
    getSplitName(idx, index_nest, total) {
      return this.splitScreenCameraList[this.splitScreenCameraList.findIndex(r => r.index === index_nest + total*idx)].cameraName;
    },
		openCameraSearchDialog(index) {
			// console.log(index)
			// console.log(this.players[index])
      this.currentItemIndex = index;
      this.searchCameraDialogVisible = true;
    },
		async goVideoPlayer(index) {
			this.$vloading.show();
			const idx = this.splitScreenCameraList.findIndex(r => r.index === index);
			const item = this.splitScreenCameraList[idx];

      this.$store.commit('setPlayerFromWhere', { from: 'privateSplitScreen', name: this.selectedSplitScreen });

      await this.$store.commit('setStreamInfo', item);
      this.$vloading.hide();
      this.pushRoute('/video-player', {
        unisCustomerCd: item.unisCustomerCd,
        customerName: item.cameraName,
      })
    },
		changeViewCount(data) {
			if(data.viewCount) {
				this.$emit('changeViewCount', data.viewCount);
				if(data.viewCount == 4) {
					this.$emit('changeViewCount', 4);
					this.view4 += 1;
				} else if(data.viewCount == 9) {
					this.$emit('changeViewCount', 9);
					this.view9 += 1;
				} else {
					this.$emit('changeViewCount', 16);
					this.view16 += 1;
				}
			} else {
				if(this.splitScreenCameraList.length === 0) {
					this.$emit('changeViewCount', 4);
					this.view4 += 1;
					return;
				}
				let length = this.splitScreenCameraList.length-1;
				if(this.splitScreenCameraList[length].index < 4) {
					this.$emit('changeViewCount', 4);
					this.view4 += 1;
				} else if(this.splitScreenCameraList[length].index > 8) {
					this.$emit('changeViewCount', 16);
					this.view16 += 1;
				} else {
					this.$emit('changeViewCount', 9);
					this.view9 += 1;
				}
			}
    },
		getAllStreamingUrl(streamData, index) {
			this.streamingCount = 0;
      let params = {};
      this.networkController.getHlsStreamingUrl(params, streamData.streamName, '', '')
      .then((res) => {
        this.splitScreenCameraList.forEach((item) => {
          if(item.streamName == streamData.streamName && item.index == streamData.index) { //이름과 index가 모두 같은 경우
            this.createPlayer(res.data.hlsstreamingSessionURL, streamData.index);
          }
        });
      }).catch(error => { });
    },
		createPlayer(videoSourceUrl, streamingCount) {
      const vm = this;
      this.players[streamingCount] = videojs(`example-${this.viewCount}-video${streamingCount}`, this.playerOptions, function onPlayerReady() {
			  this.src({
					src: videoSourceUrl,
					type: 'application/x-mpegURL'
				});
        setTimeout(() => {this.play(); }, 500);
        this.on('error', function(event) {
          console.log(event);
        });
        this.on('waiting', () => {
          setTimeout(() => {
            if (this.readyState() < 3) {
              vm.restartPlayer(streamingCount);
            }
          }, 20000);
        });
      });
      this.streamingCount = this.streamingCount + 1;
    },
		goFullScreen() {
      const container = document.getElementById('split_fullscreen');
      if (container.requestFullscreen) {
        container.requestFullscreen();
      } else if (container.mozRequestFullScreen) {
        container.mozRequestFullScreen();
      } else if (container.webkitRequestFullscreen) {
        container.webkitRequestFullscreen();
      } else if (container.msRequestFullscreen) {
        container.msRequestFullscreen();
      }
    },
		fullScreenChangeHandler() {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        // 전체화면 모드로 들어갔을 때 실행할 코드
        console.log("전체화면으로 변경되었습니다.");
      } else {
        // 전체화면 모드에서 나왔을 때 실행할 코드
				this.goDashboard()
        console.log("전체화면에서 나왔습니다.");
      }
		},
  }
}
</script>

<style lang="scss" scoped>
#camera_4box {
	background-color: #4E4E4E;
	width: 99.5%;
	height: 15rem;
	min-width: 38rem;
	min-height: 18.5rem;
	position: relative;
}
#camera_9box {
	background-color: #4E4E4E;
	width: 100%;
	height: 12rem;
	min-height: 12rem;
	position: relative;
}
#camera_16box {
	background-color: #4E4E4E;
	width: 100%;
	height: 10rem;
	min-height: 10rem;
	position: relative;
}
#transparent_btn {
  background-color: transparent;
  max-width: 4em;
  min-width: 4em;
}
#camera_select_bottom_bar {
  position: absolute;
  bottom: 0;
  text-align: left;
  padding-left: 1em !important;
  font-size: 0.8em;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.7);
  color: #A8A8A8;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
}
#split_screen_select_menu {
  background-color: transparent;
  border: 1px solid #4A4A4A;
  color: white;
  height: 2.7em;
  width: 20rem;
  justify-content: start;
}
#select_list_item {
  padding: 0px !important;
}
#select_menu_text {
  text-align: start;
	max-width: 250px;
}
#transparent_btn {
  background-color: transparent;
  max-width: 4em;
  min-width: 4em;
}
.video-js {
	width: 100%;
  height: 15rem;
	min-width: 38rem;
	min-height: 18.5rem;
  //position: absolute;
  top: 0px;
  left: 0px;
  padding: 0px;
  margin: 0px !important;
}
.video-js-9 {
	width: 100%;
  height: 100%;
	min-width: 0;
	min-height: 0;
}
.video_grey_box {
  z-index:1;
  position:absolute;
  justify-content: center;
  align-items: center;
  display: none;
  background: grey;
  height: 100%;
  top: 0px;
}
#middle_divider {
	background-color: #4C4C4C;
}
@media ( min-width: 1400px ) { 
	#camera_4box {
		min-width: 47vw;
		min-height: 40vh;
	}
	#camera_9box {
		min-height: 25vh;
	}
	#camera_16box {
		min-height: 20vh;
	}
}
</style>